import React, { useRef } from 'react'
import { sortBy } from 'lodash'
import { IProps } from './Interface'
import { Typography, Box, Chip, useMediaQuery } from '@material-ui/core'
import useStyles from './Styles'
import { Section } from 'components/section'
import { IWordBank, WordBankStatus } from 'types'
import { palette } from 'config'
import { theme } from 'config/constants/theme/theme'
import cx from 'classnames'

const isSelected = (wordBank: IWordBank, category: Category) => {
  return (
    (wordBank.status === WordBankStatus.Active || wordBank.status === WordBankStatus.Pending) &&
    category.selectedWordBanks.indexOf(wordBank._id) !== -1
  )
}

const getVisibleWordBanks = (category: Category, isMobile: boolean): IWordBank[] => {
  if (isMobile) {
    return category.wordBanks.filter(wordbank => category.selectedWordBanks.includes(wordbank._id))
  }

  return sortBy(category.wordBanks, (wordBank: IWordBank) => !isSelected(wordBank, category))
}

const Top5PageDisplay: React.FC<IProps> = ({ wordBanks, userWordBanks }) => {
  const classes = useStyles({})
  const mdSize = useMediaQuery(theme.breakpoints.down('md'))
  const borderRadius = mdSize ? {} : { topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0 }

  const categories: Category[] = [
    {
      title: 'I thrive in environments that are',
      wordBanks: wordBanks?.companyDescriptor || [],
      selectedWordBanks: (userWordBanks?.companyDescriptor || []).map(tag => tag._id),
      maxTags: 5,
      color: palette.common.purple,
      ref: useRef()
    },
    {
      title: 'My team members and friends say I am',
      wordBanks: wordBanks?.xfactor || [],
      selectedWordBanks: (userWordBanks?.xfactor || []).map(tag => tag._id),
      maxTags: 5,
      color: theme?.palette?.common?.orange,
      ref: useRef()
    },
    {
      title: 'Facts about me & my pursuits',
      wordBanks: wordBanks?.talentTags || [],
      selectedWordBanks: (userWordBanks?.talentTags || []).map(tag => tag._id),
      maxTags: 5,
      color: theme?.palette?.common?.lightBlue,
      ref: useRef()
    }
  ]

  return (
    <Section padding="0 70px 0 50px" direction="column" borderRadius={borderRadius}>
      {categories.map((category, index) => (
        <Box key={index} pb={3} width="100%" className={classes.top5Item}>
          <Box className={classes.root}>
            <Box className={classes.header}>
              <Typography id={`${index}-top-5-category-title`} variant="body1" style={{ color: category.color }}>
                {category.title}
              </Typography>
            </Box>

            <Box className={classes.content} ref={category.ref}>
              <Box className={classes.wordBanksContainer}>
                {getVisibleWordBanks(category, mdSize).map((wordBank: IWordBank, index) => (
                  <Chip
                    key={index}
                    className={cx(classes.wordbank, classes.wordBank, {
                      [classes.wordBankActive]: isSelected(wordBank, category)
                    })}
                    style={{
                      background: isSelected(wordBank, category) && category.color
                    }}
                    classes={{ root: classes.chip }}
                    label={
                      <Typography id={`${index}-top-5-tag-title`} variant="body1">
                        {wordBank.value}
                      </Typography>
                    }
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </Section>
  )
}

type Category = {
  title: string
  wordBanks: IWordBank[]
  selectedWordBanks: string[]
  maxTags: number
  color: string
  ref: React.MutableRefObject<Element | undefined>
}

export default Top5PageDisplay
